var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.16;}.b{fill:#110f0f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,5A13,13,0,1,0,31,18,12.983,12.983,0,0,0,18,5Zm0,23.718A10.718,10.718,0,1,1,28.718,18,10.733,10.733,0,0,1,18,28.718Z",
    transform: "translate(-5 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.736,33.162a4.365,4.365,0,1,0-4.218.029A6.924,6.924,0,0,0,28.3,37.12h0a8.121,8.121,0,0,0,12.682-.029l-.029.029A6.891,6.891,0,0,0,36.736,33.162Z",
    transform: "translate(-21.569 -19.151)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.4b4ea3db909004ae5f4383db3faf8377.svg";
export { ForwardRef as ReactComponent };